module.exports = __webpack_public_path__ + "img/product-preview-54.640db39.png";